export default "__VITE_ASSET__BzAY5cmk__"